const initialState = {
  sidebarMenu: JSON.parse(localStorage.getItem('sidebar_menu')) || []
}